/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';
export var DataGridFocusContext = /*#__PURE__*/React.createContext({
  setFocusedCell: function setFocusedCell() {},
  onFocusUpdate: function onFocusUpdate() {
    return function () {};
  }
});
export var DataGridSortingContext = /*#__PURE__*/React.createContext(undefined);
export var DataGridWrapperRowsContext = /*#__PURE__*/React.createContext({
  headerRow: /*#__PURE__*/React.createElement("div", null),
  headerRowHeight: 0,
  footerRow: null
});